import { useQuery, UseQueryResult, UseQueryOptions } from 'react-query';

import { ApiError, ApiRequest } from 'services/api';
import { createQueryHookOptions } from './utils';

export type RestQueryHookResult<Response = any> = UseQueryResult<Response | undefined>;
export type RestQueryHookOptions<Response = any> = Omit<
  UseQueryOptions<Response | undefined, ApiError>,
  'queryKey' | 'queryFn'
>;

/**
 * Api GET Hook
 *
 * Wrapped REST query requests with some abstractions.
 * @param url Target Endpoint URL
 * @param params Query string parameters to attach to the URL
 * @param queryOptions React-Query options
 * @param requestConfig API request config
 * @returns Response object
 */
export function useRestQuery<Response = any, Params = Record<string, unknown>>(
  url?: string,
  params?: Params,
  queryOptions?: RestQueryHookOptions<Response>,
  requestConfig?: ApiRequest,
): RestQueryHookResult<Response> {
  return useQuery(createQueryHookOptions({ url, params, queryOptions, requestConfig }));
}
